import { render, staticRenderFns } from "./LB_BBB_V2.vue?vue&type=template&id=1bf2f65d"
import script from "./LB_BBB_V2.vue?vue&type=script&lang=js"
export * from "./LB_BBB_V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports